import React, { useState, useEffect } from 'react'
// ** React Imports
import { Outlet } from "react-router-dom"
import { Clipboard, BarChart, Search } from "react-feather"
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout"
import { isUserLoggedIn } from "@utils"
import { useSelector } from "react-redux"
// import themeConfig from '../configs/themeConfig'
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"

const VerticalLayout = (props) => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const [menusData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  useEffect(() => {
    if (isUserLoggedIn()) {
      if (JSON.parse(isUserLoggedIn())?.isEmployee) {
        let enableRoute = false
        const userData = JSON.parse(localStorage.getItem('userData'))
        const userRoles = userData && userData.userRoles
        if (userRoles) {
          const findRole = userRoles.find(find => (find.rId === 1 || find.rId === 6 || find.rId === 7))
          if (findRole) {
            enableRoute = true
          }
        }
        if (enableRoute) {
          const empMenuData = JSON.parse(JSON.stringify(stores?.empMenuData))
          const findIndex = empMenuData.findIndex(find => find.id === 'appSettings')
          if (findIndex >= 0) {
            empMenuData[findIndex]['show'] = true
          }
          setMenuData(empMenuData)
        } else {
          setMenuData(stores?.empMenuData)
        }
      } else {
        setMenuData(stores?.cusMenuData)
      }
    }
  }, [isUserLoggedIn(), stores?.menuBoolean])

  return (
    <Layout menuData={menusData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
